import {CTA} from '@volkswagen-onehub/components-core';
import styled, {CSSObject} from 'styled-components';

interface IButtonProps {
  customStyles?: CSSObject;
}

export const ButtonCTAStyled = styled(CTA)<IButtonProps>`
  min-width: 297px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-text, vw-text);
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  ${(props) => props.customStyles};
`;
interface IButtonProps {
  customStyles?: CSSObject;
}
export const IconCTAStyled = styled(CTA)<IButtonProps>`
  min-width: 24px;
  min-height: 24px;
  ${(props) => props.customStyles};
`;
